import IPadAppStoreBadgeIcon from "../../assets/images/ipad-app-store-badge.svg";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";

import style from "./DownloadSection.module.css"; // eslint-disable-line

const IPadButton: React.FC<{ downloadURL: string; preferred: boolean }> = ({
  downloadURL,
  preferred,
}) => {
  const tracker = useTracker();
  const { t, m } = useTranslation();

  return (
    <div className={`${style.cell} ${style.ipad} ${preferred ? style.preferred : ""}`}>
      <div>
        <a
          target="_blank"
          rel="noreferrer noopener"
          className={style.button}
          href={downloadURL}
          onClick={() => {
            tracker.trackButtonClick({ elementId: "download-ipad" });
          }}
          title={t(m.Download.DownloadForIPadOS)}
        >
          <img src={IPadAppStoreBadgeIcon} alt={t(m.Download.IPadAppStoreIconAlt)} />
        </a>
      </div>
      <div className={style.buttonDescription}>
        <span>{t(m.Download.RequiresIPadOS)}</span>
        <div>
          <a
            rel="noreferrer noopener"
            href="https://www.shapr3d.com/compatible-devices#ipad"
            target="_blank"
          >
            {t(m.Download.SeeCompatibleIPads)}
          </a>
        </div>
      </div>
    </div>
  );
};

export default IPadButton;
